import { render, staticRenderFns } from "./PrinterTonerManagementComp.vue?vue&type=template&id=60e70fc3&scoped=true"
import script from "./PrinterTonerManagementComp.vue?vue&type=script&lang=js"
export * from "./PrinterTonerManagementComp.vue?vue&type=script&lang=js"
import style0 from "./PrinterTonerManagementComp.vue?vue&type=style&index=0&id=60e70fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e70fc3",
  null
  
)

export default component.exports